import { Grid, Link, Typography } from '@mui/material';
import React from 'react';

import { ContextStore } from '../store/contextStore';

const AccessDeniedView = () => {
    const { logout } = React.useContext(ContextStore);
    const handleLogout = (ev) => {
        logout();
    }
    return (
        <Grid container alignItems="center" justifyContent="center" p={2} style={{ height: '100%' }}>
            <Typography component="div" textAlign="center">
                <p>
                    You do not have permission to view this page, please contact support for authorization change requests.
                </p>
                <p>
                    If you have authorization and believe that this message is in error, please <Link component="button" onClick={handleLogout} sx={{ verticalAlign: 'baseline' }}>sign out</Link> and back in for reauthorization.
                </p>
            </Typography>
        </Grid>
    );
};

export default AccessDeniedView;
